import React, { Component } from 'react';

class IndividualFaq extends Component {
    constructor(props) {
        super(props);

        this.slideOpen = true;
        this.heightChecked = false;
        this.initHeight = 0;

        this.answerRef = React.createRef();
        this.buttonRef = React.createRef();

        this.state = {
            open: false,
        };
    }

    componentDidMount() {
        this.slideToggle();
    }

    showFaq = () => {
        this.setState(
            prevState => {
                return {
                    open: !prevState.open,
                };
            },
            () => this.slideToggle()
        );
    };

    slideToggle = () => {
        const answer = this.answerRef.current;
        const button = this.buttonRef.current;

        if (!this.heightChecked) {
            this.initHeight = answer.offsetHeight;
            this.heightChecked = true;
            button.style.background = "#999999";
        }
        if (this.slideOpen) {
            this.slideOpen = false;
            answer.style.height = '0px';
            button.style.background = "#00b8f4";
        } else {
            this.slideOpen = true;
            answer.style.height = this.initHeight + 'px';
            button.style.background = "#999999";
        }
    };

    render() {
        const { faq } = this.props;
        const { open } = this.state;
        return (
            <div className={`faq ${open ? 'open' : ''}`}>
                <div className="top-flex" onClick={() => this.showFaq()}>
                    
                    <div className="button-wrap"><button ref={this.buttonRef} /></div>
                    <p
                        className="question"
                        dangerouslySetInnerHTML={{ __html: faq.question }}
                    />
                </div>
                <p
                    className="answer"
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ref={this.answerRef}
                />
            </div>
        );
    }
}

export default IndividualFaq;